import React, { useState } from 'react';

import Modal from '../base/Modal';

const TitleDescriptionModal = ({
  initialTitle,
  initialDescription,
  onClose,
  onSave,
  viewOnly,
}) => {
  const [title, setTitle] = useState(initialTitle);
  const [description, setDescription] = useState(initialDescription);

  const handleSave = () => {
    onSave(title, description);
  };

  return (
    <Modal
      title={viewOnly ? 'View Workflow' : 'Edit Workflow'}
      isOpen={true}
      onClose={onClose}
    >
      <div className="flex flex-col gap-4 bg-zinc-900 p-4">
        <div className="space-y-2">
          <label
            htmlFor="title"
            className="block text-sm font-medium text-zinc-300"
          >
            Workflow Title
          </label>
          <input
            id="title"
            type="text"
            value={title}
            disabled={viewOnly}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter workflow title"
            className="w-full rounded-md border border-zinc-700 bg-zinc-800 px-3 py-2 text-zinc-100
                     placeholder-zinc-500 transition duration-200 focus:border-transparent focus:outline-none
                     focus:ring-2 focus:ring-[#5652CF]"
          />
        </div>

        <div className="space-y-2">
          <label
            htmlFor="description"
            className="block text-sm font-medium text-zinc-300"
          >
            Workflow Description
          </label>
          <textarea
            id="description"
            value={description}
            disabled={viewOnly}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter workflow description"
            rows={4}
            className="w-full resize-none rounded-md border border-zinc-700 bg-zinc-800 px-3 py-2
                     text-zinc-100 placeholder-zinc-500 transition duration-200 focus:border-transparent
                     focus:outline-none focus:ring-2 focus:ring-[#5652CF]"
          />
        </div>
        {!viewOnly && (
          <div className="mt-2 flex justify-end gap-3">
            <button
              onClick={handleSave}
              className="rounded-md border border-zinc-700 bg-zinc-800 px-4 
                     py-2 text-zinc-300 transition duration-200 hover:bg-zinc-700
                     focus:outline-none focus:ring-2 focus:ring-zinc-500"
            >
              Save Changes
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TitleDescriptionModal;
